import { iconsStatusMatcher } from '../../../../utils/generators/iconsStatusMatcher.jsx'
import { Icons } from '../../../../common/Icons.jsx'
import { optionsProjektStatus, optionsHarmStatus, optionsSprawozdanieStatus } from '../../../../utils/options.js'

export const createTableLista = (data) => {
    return [
        {
            accessorKey: 'id',
            header: 'ID',
            enableColumnFilter: true,
            filterFn: 'includesString',
            poprawa: 1,
            przypisz: 1,
        },
        {
            accessorKey: 'numer',
            header: 'Numer',
            enableColumnFilter: true,
            filterFn: 'includesString',
            poprawa: 1,
            przypisz: 1,
        },
        {
            accessorKey: 'tytul',
            header: 'Tytuł',
            enableColumnFilter: true,
            filterFn: 'includesString',
            poprawa: 1,
            przypisz: 1,
        },
        {
            accessorKey: 'podmiot',
            header: 'Nazwa jednostki',
            enableColumnFilter: true,
            filterFn: 'includesString',
            poprawa: 1,
            przypisz: 1,
        },
        {
            accessorKey: 'kategoria',
            header: 'Kategoria',
            enableColumnFilter: true,
            filterFn: 'includesString',
            poprawa: 1,
            przypisz: 1,
        },
        {
            accessorKey: 'projekt_status',
            filterFn: 'equals',
            header: 'Status karty projektu',
            cell: ({ row }) => {
                const status = row.original.projekt_status
                const icon = iconsStatusMatcher[status]?.icon
                const color = iconsStatusMatcher[status]?.color
                const prosbaOdblokowanie = row.original.projekt_czy_prosba_odblokowanie === "Tak"
                const isAnulowana = row.original.projekt_status === 'ANULOWANA'
                const hasProsbaAnulowania = row.original.czy_prosba_anulowania === 'Tak'
                const hasProsbaWznowienia = row.original.projekt_czy_prosba_wznowienia === 'Tak'

                return (
                    <div
                        className={
                            'd-flex ms-2 gap-2 align-content-center align-items-center'
                        }
                    >
                        <span
                            className={`p-1 text-${color}`}
                        >
                            {icon}
                        </span>
                        <div className="d-flex flex-column">
                            <div>{status}</div>
                            {prosbaOdblokowanie && !isAnulowana && (
                                <small title={'Prośba o odblokowanie'} className="text-warning fw-bold d-flex align-items-center gap-1">
                                    <Icons.unlock size={22} />
                                </small>
                            )}
                            {hasProsbaWznowienia && isAnulowana && (
                                <small title={'Prośba o wznowienie'} className="text-success fw-bold d-flex align-items-center gap-1">
                                    <Icons.update size={22} />
                                </small>
                            )}
                        </div>
                        {hasProsbaAnulowania && !isAnulowana && (
                            <span className="text-danger ms-1" title="Prośba o anulowanie">
                                <Icons.cancel size={18} />
                            </span>
                        )}
                    </div>
                )
            },
            poprawa: 1,
            meta: {
                filterVariant: 'select',
                options: optionsProjektStatus,
            },
        },
        {
            accessorKey: 'plan_harm_status',
            filterFn: 'equals',
            header: 'Status harm.',
            cell: ({ row }) => {
                const status = row.original.plan_harm_status
                const icon = iconsStatusMatcher[status]?.icon
                const color = iconsStatusMatcher[status]?.color
                const prosbaOdblokowanie = row.original.plan_harm_czy_prosba_odblokowanie === "Tak"

                return (
                    <div
                        className={
                            'd-flex ms-2 gap-2 align-content-center align-items-center'
                        }
                    >
                        <span
                            className={`p-1 text-${color}`}
                        >
                            {icon}
                        </span>
                        <div className="d-flex flex-column">
                            <div>{status}</div>
                            {prosbaOdblokowanie && (
                                <small title={'Prośba o odblokowanie'} className="text-warning fw-bold d-flex align-items-center gap-1">
                                    <Icons.unlock size={22}  />
                                </small>
                            )}
                        </div>
                    </div>
                )
            },
            poprawa: 1,
            meta: {
                filterVariant: 'select',
                options: optionsHarmStatus,
            },
        },
        {
            accessorKey: 'sprawozdanie_status',
            filterFn: 'equals',
            header: 'Status sprawozdania',
            cell: ({ row }) => {
                const status = row.original.sprawozdanie_status
                const icon = iconsStatusMatcher[status]?.icon
                const color = iconsStatusMatcher[status]?.color
                const prosbaOdblokowanie = row.original.sprawozdanie_czy_prosba_odblokowanie === 'Tak'
                const prosbaTymczasoweOdblokowanie = row.original.czy_prosba_tymczasowe_odblokowanie_spr === 'Tak'
                const tymczasoweOdblokowanie = row.original.czy_tymczasowe_odblokowanie_spr === 'Tak'

                return (
                    <div
                        className={
                            'd-flex ms-2 gap-2 align-content-center align-items-center'
                        }
                    >
                        <span
                            className={`p-1 text-${color}`}
                        >
                            {icon}
                        </span>
                        <div className="d-flex flex-column">
                            <div>{status}</div>
                            {prosbaOdblokowanie && (
                                <small title={'Prośba o odblokowanie sprawozdania'} className="text-warning fw-bold d-flex align-items-center gap-1">
                                    <Icons.unlock size={22} />
                                </small>
                            )}
                            {prosbaTymczasoweOdblokowanie && !tymczasoweOdblokowanie && (
                                <small title={'Prośba o tymczasowe odblokowanie sprawozdawczości'} className="text-warning fw-bold d-flex align-items-center gap-1">
                                    <Icons.unlock size={22} />
                                    <span style={{fontSize: '0.7em'}}>tymcz.</span>
                                </small>
                            )}
                            {tymczasoweOdblokowanie && (
                                <small title={'Tymczasowe odblokowanie sprawozdawczości aktywne'} className="text-success fw-bold d-flex align-items-center gap-1">
                                    <Icons.unlock size={22} />
                                    <span style={{fontSize: '0.7em'}}>tymcz.</span>
                                </small>
                            )}
                        </div>
                    </div>
                )
            },
            poprawa: 1,
            meta: {
                filterVariant: 'select',
                options: optionsSprawozdanieStatus,
            },
        },
        {
            accessorKey: 'wersja',
            header: 'Wersja karty projektu',
            filterFn: 'includesString',
            przypisz: 1,
            wszystkie: 1,
        },
        {
            accessorKey: 'plan_harm_wersja',
            header: 'Wersja plan. harm.',
            filterFn: 'includesString',
            przypisz: 1,
            wszystkie: 1,
        },
        {
            accessorKey: 'sprawozdanie_numer',
            header: 'Numer sprawozdania',
            filterFn: 'includesString',
            przypisz: 1,
            wszystkie: 1,
        },
        {
            accessorKey: 'sprawozdanie_data_zlozenia',
            header: 'Data złożenia sprawozdania',
            filterFn: 'includesString',
            przypisz: 1,
            wszystkie: 1,
        },
    ]
}
